import Cookies from "universal-cookie";

// TODO: May need to refactor into a cookie fetching module
export function getCSRFToken() {
  const c = new Cookies();
  return c.get("csrftoken");
}
